import { useState } from 'react'
import {
  SupplyChainFilters,
  type FilterValues,
} from '@/components/supply-chain/SupplyChainFilters'
import { SupplyChainStats } from '@/components/supply-chain/SupplyChainStats'
import { SupplyChainFeed } from '@/components/supply-chain/SupplyChainFeed'

/**
 * Incidents tab content for the Supply Chain surface — the original
 * `/threats/supply-chain` body (Plan C Plan 2 T16) extracted so the
 * page shell can host an additional Providers tab alongside it.
 *
 * Composes the stats rail, filter bar, and paginated incident feed
 * against `/api/supply-chain/incidents`, `/api/supply-chain/stats`,
 * and `/api/providers` (for the provider chip selector).
 *
 * Owns its own filter state — switching tabs and back resets the
 * filter, which matches the Analytics tab pattern (sector state on
 * CompareTab is local, not lifted).
 */
export function IncidentsView() {
  const [filters, setFilters] = useState<FilterValues>({})

  return (
    <div className="flex flex-col gap-6">
      <SupplyChainStats filters={filters} />
      <SupplyChainFilters value={filters} onChange={setFilters} />
      <SupplyChainFeed filters={filters} />
    </div>
  )
}

export default IncidentsView
